import React, { useEffect, useMemo } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import { DashboardHeader } from '../../../components/common';
import PricingBatchesTable from '../../../components/requests/PricingBatchesTable';
import RequestDrawer from '../../../components/requests/RequestDrawer';
import {
    RequestDrawerProvider,
    useRequestDrawer,
} from '../../../context/RequestDrawerContext';
import { useAuth } from '../../../context/AuthProvider';
import { getIsPricingBatchesModuleEnabled } from '../../../constants/navigation';
import { useAppConfig } from '../../../hooks/useAppConfig';
import Loader from '../../../components/common/Loader';

function PricingBatchesHomePageContent() {
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        open,
        close,
        isOpen,
        requestId: contextRequestId,
    } = useRequestDrawer();

    const requestId = useMemo(() => {
        return searchParams.get('requestId');
    }, [searchParams]);

    useEffect(() => {
        if (requestId && !isOpen) {
            open(null, requestId);
        }
    }, [requestId, isOpen, open]);

    useEffect(() => {
        if (requestId && isOpen && requestId !== contextRequestId) {
            open(null, requestId);
        }
    }, [requestId, isOpen, contextRequestId, open]);

    const handleClose = () => {
        close();
        setSearchParams(previousParams => {
            const nextParams = new URLSearchParams(previousParams);
            nextParams.delete('requestId');
            return nextParams;
        });
    };

    return (
        <>
            <RequestDrawer onClose={handleClose} />
            <div className="relative">
                <DashboardHeader
                    friendlyLabels={[
                        {
                            originalLabel: 'price-change',
                            friendlyLabel: 'Price Change',
                        },
                        {
                            originalLabel: 'pricing-batches',
                            friendlyLabel: 'Pricing batches',
                        },
                    ]}
                    title="Pricing batches"
                />
                <div className="px-11">
                    <PricingBatchesTable />
                </div>
            </div>
        </>
    );
}

function PricingBatchesHomePage() {
    const { authUser, role } = useAuth();
    const { pricingBatchesModuleEnabled, loading } = useAppConfig();

    if (loading) {
        return (
            <div className="flex justify-center p-12">
                <Loader />
            </div>
        );
    }

    if (
        !getIsPricingBatchesModuleEnabled(
            authUser,
            role,
            pricingBatchesModuleEnabled,
        )
    ) {
        return <Navigate to="/price-change" replace />;
    }

    return (
        <RequestDrawerProvider>
            <PricingBatchesHomePageContent />
        </RequestDrawerProvider>
    );
}

export default PricingBatchesHomePage;
